<template>
  <section class="short-link-view">
    <LoadingSpinnerComponent v-if="isLoading" />
    <div v-else>
      <h1>Short Links</h1>
      <hr/>
      <p>Create and manage your short links.</p>
      <br>
      
      <ShortLinkCreateForm />
      
      <div v-if="isAuthenticated">
        <h2>Your Links</h2>
        <ShortLinkTable />
      </div>
    </div>
  </section>
</template>

<script>
import { defineComponent } from 'vue';
import { mapGetters, mapState } from 'vuex';
import LoadingSpinnerComponent from "@/components/LoadingSpinnerComponent.vue";
import ShortLinkCreateForm from "@/components/ShortLinkCreateForm.vue";
import ShortLinkTable from "@/components/ShortLinkTable.vue";

export default defineComponent({
  name: 'ShortLinkView',
  
  components: {
    LoadingSpinnerComponent,
    ShortLinkCreateForm,
    ShortLinkTable
  },

  computed: {
    ...mapGetters('auth', ['isAuthenticated']),
    ...mapState('auth', ['loading']),
    isLoading() {
      return this.loading;
    }
  }
});
</script>

<style scoped>
.short-link-view {
  padding: 1rem 0;
  min-height: calc(100vh - 200px);
}

@media (max-width: 768px) {
  .short-link-view {
    padding: 0.5rem 0;
  }
}
</style>